import React from "react";
import styled from "styled-components";
const FormError = styled.div`
    color: #ff7b7b;
    margin: -6px 0 6px 124px;
    font-size: 11px;
`;

let Error = ({error}) => {
 return <FormError className="form-error">
            {error}
        </FormError>

};

export default Error;
